import { p } from '@/utils/content-blocks';

export const ANTI_BAN_CHECKLIST = [
	'Keep GB WhatsApp on the latest v18.80 build from GBWaps',
	'Back up chats before every update',
	'Avoid bulk forwarding to hundreds of new numbers',
	'Warm up the account 48h with normal chats after install',
	'Enable privacy toggles gradually—not all at once on day one',
	'Do not spam groups or blast identical promos',
	'Skip shady sticker packs from unknown URLs',
];

export const RISK_TIPS = [
	{
		title: 'Outdated APK',
		text: 'Old clients miss server heartbeat fixes—update promptly when the app warns you.',
		level: 'high',
	},
	{
		title: 'Mass broadcasts',
		text: 'Identical promos to many contacts look like spam to Meta systems.',
		level: 'high',
	},
	{
		title: 'Aggressive privacy day one',
		text: 'Hiding everything immediately after login can flag fresh sessions.',
		level: 'medium',
	},
	{
		title: 'Third-party repacks',
		text: 'Random mirrors may use patched signatures that bans hit faster.',
		level: 'high',
	},
];

export const ANTI_BAN_SECTIONS = [
	{
		id: 'what-is-anti-ban',
		h2: 'What is Anti-Ban in GB WhatsApp',
		blocks: [
			p([
				{
					text: '“Anti-ban” means developer-side tweaks that mimic official client behavior plus user habits that avoid spam patterns. It is risk reduction—not a guarantee Meta will ignore unofficial apps.',
				},
			]),
			p([
				{
					text: 'v18.80 marketing often labels builds as anti-ban. Treat that as fewer problems, not immunity—especially on your main SIM.',
				},
			]),
		],
	},
	{
		id: 'why-banned',
		h2: 'Why Accounts Get Banned',
		blocks: [
			p([
				{
					text: 'Meta detects unsupported clients, bulk messaging, and suspicious login patterns. Temporary bans show a countdown; some numbers need official WhatsApp again afterward.',
				},
			]),
			p([
				{
					text: 'Switching between five different mods in one day, revoking dozens of messages, or joining hundreds of groups instantly raises risk scores.',
				},
			]),
		],
	},
	{
		id: 'how-works',
		h2: 'How Anti-Ban System Works',
		blocks: [
			p([
				{
					text: 'Mod teams delay certain heartbeat packets and adjust user-agent strings to resemble stock apps. When Meta updates detection, developers ship new APKs—another reason to stay on 18.80.',
				},
			]),
			p([
				{
					text: 'Your behavior still matters: anti-ban code cannot fix mass promotional blasts or reported spam.',
				},
			]),
		],
	},
	{
		id: 'safe-tips',
		h2: 'Safe Usage Tips',
		layout: 'risk-tips',
		blocks: [
			p([
				{
					text: 'Use a secondary number first if you are testing mods. Keep official WhatsApp for banking OTPs and work-critical threads.',
				},
			]),
			p([
				{ text: 'Update through the ' },
				{ link: { to: '/gbwhatsapp-update/', text: 'GB WhatsApp update guide' } },
				{ text: ' instead of hopping random mirrors mid-week.' },
			]),
		],
	},
	{
		id: 'settings',
		h2: 'Settings to Reduce Ban Risk',
		layout: 'checklist',
		blocks: [
			p([
				{
					text: 'In GB Settings, enable anti-ban options if your build exposes them. Pair with hide-online and DND only after the warm-up window.',
				},
			]),
			p([
				{
					text: 'Disable auto-reply blasting to full contact lists. Schedule messages sparingly and personalize text.',
				},
			]),
		],
	},
	{
		id: 'if-banned',
		h2: 'What to Do If Banned',
		blocks: [
			p([
				{
					text: 'Read the timer—do not reinstall five mods hourly. Wait it out, backup if you still have access, then install the newest APK once from GBWaps.',
				},
			]),
			p([
				{
					text: 'Permanent loss is rare but possible. Move important threads to official WhatsApp with a fresh number if Meta blocks repeats.',
				},
			]),
		],
	},
	{
		id: 'recovery',
		h2: 'Recovery Methods',
		blocks: [
			p([
				{
					text: 'After a temp ban lifts, open the latest 18.80, restore backup, send a few 1:1 chats, avoid groups for 24 hours. Clear cache only if login loops persist.',
				},
			]),
			p([
				{ text: 'Fresh install path: follow ' },
				{ link: { to: '/install-gbwhatsapp/', text: 'How to Install GB WhatsApp APK' } },
				{ text: ' on a clean APK without uninstalling official WhatsApp for your other number.' },
			]),
		],
	},
];
